import { Tab } from "@components/templates/Tab";
import { companyPayload, logisticsPayload, pendoEventType, tabDataHandler } from "../../utils/constant";
import { profileType } from "@utils/enum";
import { useDispatch } from "react-redux";
import { getFavouriteDetailsHandler } from "@redux/Bookmark/bookmark.action";
import { loadingBookmarkData, resetBookmarkData } from "@redux/Bookmark/bookmarksSlice";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import getTrackingEventDictionary from "@core/dictionary/tracking-event";

export const TabComponent = ({ setType, setPayload, clearSelection, setCurrentPage }) => {
  const dispatch = useDispatch();

  const onClickHandler = (index) => {
    if (tabDataHandler[index]?.value === profileType.logistics) {
      dispatch(loadingBookmarkData());
      dispatch(resetBookmarkData());
      dispatch(getFavouriteDetailsHandler({ payload: logisticsPayload }));
      setType(profileType.logistics);
      setPayload(logisticsPayload);
      clearSelection();
      setCurrentPage(1);
      trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[tabDataHandler[index]?.value] + "tab", generateTrackingObject("intel-logistics-favourite"));
    } else {
      dispatch(loadingBookmarkData());
      dispatch(resetBookmarkData());
      dispatch(getFavouriteDetailsHandler({ payload: companyPayload }));
      setType(profileType.company);
      setPayload(companyPayload);
      clearSelection();
      setCurrentPage(1);
      trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[tabDataHandler[index]?.value] + "tab", generateTrackingObject("intel-companies-favourite"));
    }
  };

  return (
    <div>
      <Tab options={tabDataHandler} onClick={onClickHandler} />
    </div>
  );
};
